import { FunctionComponent } from 'react'
import { Box, Typography } from '@material-ui/core'
import { Notification } from 'common/types/notification.types'
import styled from 'styled-components/macro'
import { ReactComponent as AlertIcon } from 'icons/alert.svg'
import { ReactComponent as NewNotification } from 'icons/notification.svg'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { NavButton } from 'common/atoms/NavButton/NavButton'
import { PathName } from 'common/types/pathName.types'
import { useLocation } from 'react-router-dom'

const Alert = styled(AlertIcon)`
  cursor: pointer;
`

const AlertContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 1.5626rem;
  height: 1.5626rem;
`

const New = styled(NewNotification)`
  top: 0;
  right: 0;
  position: absolute;
`

const NotificationContainer = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

interface NotificationProps {
  theme: any
  setDrawer: Function
  setTab: Function
  showAlert: boolean
  handleClick: Function
  drawer?: boolean
}

export const Notifications: FunctionComponent<NotificationProps> = ({
  theme,
  handleClick,
  setTab,
  showAlert,
  drawer
}) => {
  const { isDevice } = useScreenSizes()
  const { logEventAnalytics } = useAnalytics()
  const { backendPartner, backendUser } = useAuth()
  const { pathname } = useLocation()

  return (
    <NavButton
      onClick={() => {
        const partnerLog = {}
        const userLog = {}
        userLog['User ID'] = backendUser?.id
        if (backendUser?.partnerId) {
          partnerLog['Partner ID'] = backendPartner?.id
          partnerLog['Company Name'] = backendPartner?.name
          partnerLog['Account Type'] = 'Partner'
        } else {
          userLog['Account Type'] = backendUser?.role
        }
        logEventAnalytics(
          backendUser?.partnerId ? 'Partner' : backendUser?.role,
          'Notification opened',
          'mixpanel',
          'Notification opened',
          {
            ...userLog,
            ...partnerLog
          },
          backendUser?.id,
          {
            $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
            $email: backendUser?.username
          }
        )
        handleClick()
        setTab(0)
      }}
      active={pathname === PathName.PINGS || drawer}
      icon={
        <AlertContainer>
          <Alert fill={pathname === PathName.PINGS || drawer ? theme.colors.primary : theme.colors.accent} />
          {showAlert && <New />}
        </AlertContainer>
      }
      label="Pings"
      href={PathName.PINGS}
      height="46px"
    />
  )
}
